var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AdCropper_Logo_Light",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 158 26.2",
    style: {
      enableBackground: "new 0 0 158 26.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000118396919913563163980000017632857581512632713_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#94F956;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    transform: "translate(31.14 0.677)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 126.9,
    height: 25.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130635304257027581060000013093768955973998509_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    style: {
      clipPath: "url(#SVGID_00000130635304257027581060000013093768955973998509_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    className: "st1",
    d: "M0.8,7.9c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.1-0.9,3.3-0.9c1,0,1.9,0.2,2.8,0.6 c0.7,0.4,1.4,0.9,1.9,1.6v-2h3.6v14.1h-3.6v-2.1c-0.5,0.7-1.1,1.3-1.9,1.6C8.3,18.8,7.4,19,6.4,19c-1.1,0-2.3-0.3-3.2-0.9 c-1-0.6-1.8-1.5-2.3-2.6C0.3,14.3,0,13,0,11.7C0,10.4,0.3,9.1,0.8,7.9L0.8,7.9z M10.6,9.5c-0.3-0.6-0.8-1.1-1.4-1.4 C8.6,7.8,8,7.6,7.3,7.6c-0.6,0-1.3,0.2-1.8,0.5c-0.6,0.3-1,0.8-1.4,1.4c-0.4,0.7-0.5,1.4-0.5,2.2c0,0.8,0.2,1.5,0.5,2.2 c0.3,0.6,0.8,1.1,1.4,1.5c0.5,0.3,1.2,0.5,1.8,0.5c0.7,0,1.3-0.2,1.9-0.5c0.6-0.3,1.1-0.8,1.4-1.4C11.2,12.6,11.2,10.9,10.6,9.5 L10.6,9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    className: "st1",
    d: "M17,7.9c1-2.1,3.2-3.5,5.6-3.4c0.9,0,1.8,0.2,2.6,0.6c0.8,0.4,1.5,0.9,2,1.6V1.6L30.8,0v18.8 h-3.6v-2.1c-0.5,0.7-1.1,1.3-1.9,1.7c-0.9,0.4-1.8,0.7-2.8,0.6c-1.1,0-2.3-0.3-3.2-0.9c-1-0.6-1.8-1.5-2.3-2.6 c-0.6-1.2-0.9-2.5-0.9-3.8C16.2,10.4,16.5,9.1,17,7.9L17,7.9z M26.8,9.5c-0.3-0.6-0.8-1.1-1.4-1.4c-0.6-0.3-1.2-0.5-1.9-0.5 c-0.6,0-1.3,0.2-1.8,0.5c-0.6,0.3-1,0.8-1.4,1.4c-0.4,0.7-0.5,1.4-0.5,2.2c0,0.8,0.2,1.5,0.5,2.2c0.3,0.6,0.8,1.1,1.4,1.5 c0.5,0.3,1.2,0.5,1.8,0.5c0.7,0,1.3-0.2,1.9-0.5c0.6-0.3,1.1-0.8,1.4-1.4c0.4-0.7,0.5-1.4,0.5-2.2C27.3,11,27.1,10.2,26.8,9.5 L26.8,9.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    className: "st1",
    d: "M33.3,7.9c0.6-1.1,1.4-1.9,2.5-2.5c1.1-0.6,2.3-0.9,3.6-0.9c1.5-0.1,3.1,0.4,4.3,1.3 c1.2,0.9,2,2.2,2.3,3.7h-3.8c-0.2-0.6-0.5-1.1-1-1.4c-0.5-0.4-1.2-0.5-1.8-0.5c-0.9,0-1.8,0.4-2.4,1.1c-0.6,0.9-1,2-0.9,3.1 c-0.1,1.1,0.2,2.2,0.9,3.1c0.6,0.7,1.5,1.1,2.4,1.1c1.3,0.1,2.5-0.7,2.8-1.9H46c-0.3,1.4-1.1,2.7-2.3,3.6 c-1.2,0.9-2.8,1.4-4.3,1.3c-1.3,0-2.5-0.3-3.6-0.9c-1-0.6-1.9-1.5-2.5-2.5c-0.6-1.2-0.9-2.5-0.9-3.8C32.4,10.4,32.7,9.1,33.3,7.9 L33.3,7.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    className: "st1",
    d: "M52.9,5.2c0.8-0.4,1.6-0.7,2.5-0.6v3.7h-0.9C53.6,8.2,52.7,8.5,52,9c-0.6,0.8-1,1.7-0.9,2.7v7 h-3.6V4.7h3.6v2.2C51.6,6.2,52.2,5.6,52.9,5.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    className: "st1",
    d: "M59.4,18.1c-1.1-0.6-2-1.5-2.6-2.6c-0.6-1.2-1-2.5-0.9-3.8c0-1.3,0.3-2.6,1-3.8 c0.6-1.1,1.5-2,2.6-2.5c2.3-1.2,5.1-1.2,7.4,0c1.1,0.6,2,1.5,2.6,2.5c0.7,1.2,1,2.5,1,3.8c0,1.3-0.3,2.7-1,3.8 c-0.6,1.1-1.5,2-2.6,2.6c-1.1,0.6-2.4,0.9-3.7,0.9C61.8,19,60.5,18.7,59.4,18.1 M64.9,15.4c0.6-0.3,1.1-0.8,1.4-1.4 c0.4-0.7,0.5-1.5,0.5-2.3c0.1-1.1-0.3-2.2-1.1-3.1C65,8,64.1,7.6,63.1,7.6c-1,0-1.9,0.4-2.6,1.1c-0.7,0.9-1.1,2-1,3.1 c-0.1,1.1,0.3,2.2,1,3.1c0.6,0.7,1.6,1.1,2.5,1.1C63.7,15.9,64.3,15.8,64.9,15.4L64.9,15.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    className: "st1",
    d: "M77.4,5.1c0.8-0.4,1.8-0.7,2.8-0.6c1.1,0,2.3,0.3,3.3,0.9c1,0.6,1.8,1.5,2.3,2.5 c0.6,1.2,0.9,2.5,0.9,3.8c0,1.3-0.3,2.6-0.9,3.8c-0.5,1.1-1.3,1.9-2.3,2.6c-1,0.6-2.1,0.9-3.3,0.9c-0.9,0-1.9-0.2-2.7-0.6 c-0.7-0.4-1.4-0.9-1.9-1.6v7.1L72,25.5V4.7h3.6v2C76,6.1,76.7,5.5,77.4,5.1L77.4,5.1z M82.5,9.5c-0.3-0.6-0.8-1.1-1.4-1.4 c-0.6-0.3-1.2-0.5-1.8-0.5c-0.6,0-1.3,0.2-1.8,0.5c-0.6,0.3-1.1,0.8-1.4,1.4c-0.7,1.4-0.7,3,0,4.4c0.3,0.6,0.8,1.1,1.4,1.4 c1.1,0.7,2.5,0.7,3.7,0c0.6-0.4,1.1-0.9,1.4-1.4c0.4-0.7,0.5-1.5,0.5-2.2C83,10.9,82.8,10.2,82.5,9.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    className: "st1",
    d: "M93.6,5.1c0.8-0.4,1.8-0.7,2.8-0.6c1.1,0,2.3,0.3,3.3,0.9c1,0.6,1.8,1.5,2.3,2.5 c0.6,1.2,0.9,2.5,0.9,3.8c0,1.3-0.3,2.6-0.9,3.8c-0.5,1.1-1.3,1.9-2.3,2.6c-1,0.6-2.1,0.9-3.3,0.9c-0.9,0-1.9-0.2-2.7-0.6 c-0.7-0.4-1.4-0.9-1.9-1.6v7.1l-3.6,1.6V4.7h3.6v2C92.2,6.1,92.9,5.5,93.6,5.1L93.6,5.1z M98.7,9.5c-0.3-0.6-0.8-1.1-1.4-1.4 c-0.6-0.3-1.2-0.5-1.8-0.5c-0.6,0-1.3,0.2-1.8,0.5c-0.6,0.3-1.1,0.8-1.4,1.4c-0.7,1.4-0.7,3,0,4.4c0.3,0.6,0.8,1.1,1.4,1.4 c1.1,0.7,2.5,0.7,3.7,0c0.6-0.4,1.1-0.9,1.4-1.4c0.4-0.7,0.5-1.5,0.5-2.2C99.2,10.9,99,10.2,98.7,9.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    className: "st1",
    d: "M117.4,12.8h-10.3c0,0.9,0.4,1.8,1.1,2.4c0.6,0.6,1.5,0.9,2.3,0.9c1.2,0.1,2.3-0.6,2.8-1.7 h3.8c-0.4,1.3-1.2,2.5-2.3,3.3c-1.2,0.9-2.7,1.4-4.2,1.3c-1.3,0-2.5-0.3-3.6-0.9c-1.1-0.6-1.9-1.5-2.5-2.6 c-0.6-1.2-0.9-2.5-0.9-3.8c0-1.3,0.3-2.6,0.9-3.8c0.6-1.1,1.4-2,2.5-2.5c1.1-0.6,2.4-0.9,3.7-0.9c1.3,0,2.5,0.3,3.6,0.9 c1,0.6,1.9,1.4,2.5,2.4c0.6,1.1,0.9,2.4,0.9,3.6C117.5,11.9,117.4,12.4,117.4,12.8z M113.8,10.4c0-0.8-0.3-1.7-1-2.2 c-0.7-0.6-1.5-0.9-2.4-0.8c-0.8,0-1.6,0.3-2.2,0.8c-0.6,0.6-1,1.4-1.1,2.2L113.8,10.4L113.8,10.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    className: "st1",
    d: "M124.4,5.2c0.8-0.4,1.6-0.7,2.5-0.6v3.7H126c-0.9-0.1-1.8,0.2-2.5,0.8c-0.6,0.8-1,1.7-0.9,2.7 v7H119V4.7h3.6v2.2C123,6.2,123.6,5.6,124.4,5.2"
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    className: "st1",
    d: "M13.9,5.8L21,19.4H7.1L13.9,5.8z M15.4,0l-3.7,1.6L0,21.9l6,4h16l-1-6.5l7.1,2.5L15.4,0z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    className: "st2",
    d: "M22.1,25.9l6-4l0,0L21,19.4L22.1,25.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.47698b35a11c61ad2798c29264f7fe65.svg";
export { ForwardRef as ReactComponent };